import React, { Component } from 'react'
import pina from "./../../assets/img/pina.svg";
import tetera from "./../../assets/img/tetera.svg";
import defaultImg1 from './../../assets/img/preloaders/1.jpg'
import defaultImg2 from './../../assets/img/preloaders/2.jpg'
import defaultImg3 from './../../assets/img/preloaders/3.jpg'
import defaultImg4 from './../../assets/img/preloaders/4.jpg'
import defaultImg5 from './../../assets/img/preloaders/5.jpg'

class LaCartaGrid extends Component {
  bgCarta() {
    return { 
      backgroundImage: `url(${this.props.apiHome.bg_seccion_carta ? this.props.apiHome.bg_seccion_carta.sizes.sm : defaultImg1})`
    }
  }

  bgDesayunos() {
    return {
      backgroundImage: `url(${this.props.apiHome.bg_seccion_coctel ? this.props.apiHome.bg_seccion_coctel.sizes.medium_large : defaultImg2})`
    }
  }

  bgBebidas() {
    return {
      backgroundImage: `url(${this.props.apiHome.bg_seccion_vino ? this.props.apiHome.bg_seccion_vino.sizes.medium_large : defaultImg3})`
    }
  }

  bgPostres() {
    return {
      backgroundImage: `url(${this.props.apiHome.bg_seccion_postres ? this.props.apiHome.bg_seccion_postres.sizes.medium_large : defaultImg4})`
    }
  }
  
  bgLlevar() {
    return {
      backgroundImage: `url(${this.props.apiHome.bg_seccion_llevar ? this.props.apiHome.bg_seccion_llevar.sizes.medium_large : defaultImg5})`
    }
  }

  startModal(id) {
    document.getElementById(id).classList.add('is-active');
  }

  closeModal(id) {
    document.getElementById(id).classList.remove('is-active');
  }

  // slider() {
  //   const controls = document.querySelectorAll('.controls');

  //   for (let i = 0; i < controls.length; i++) {
  //     controls[i].style.display = 'inline-block';
  //   }

  //   const slides = document.querySelectorAll('#slides .slide');
  //   let currentSlide = 0;
  //   const slideInterval = setInterval(nextSlide, 4000);

  //   const goToSlide = (n) => {
  //     slides[currentSlide].className = 'slide';
  //     currentSlide = (n + slides.length) % slides.length;
  //     slides[currentSlide].className = 'slide showing';
  //   }

  //   const nextSlide = () => {
  //     goToSlide(currentSlide + 1);
  //   }

  //   const previousSlide = () => {
  //     goToSlide(currentSlide - 1);
  //   }

  //   const next = document.getElementById('next');
  //   const previous = document.getElementById('previous');

  //   const n = () => {
  //     next.nextSlide();
  //   };
  //   const p = () => {
  //     previous.previousSlide();
  //   };
  // }

  sliderItems(el) {
    if (el) {
      return el.map((obj) => {
        return (

          <li className="slide showing" 
            key={obj.slider_item.id}
            style={{ backgroundImage: `url(${obj.slider_item.url})` }}
          ></li>  
        )
      })

    }
  }

  componentWillReceiveProps() {
  }
  
  render() {
    // this.slider();
    return (
      <section id="js-carta-grid" className="section grid-padding"
        data-aos="fade" data-aos-duration="650" data-aos-delay="360" data-aos-offset="160" data-aos-easing="ease-in-out-quad">
        <img className="pina" src={pina} alt="" />
        <img className="tetera" src={tetera} alt="" />
  
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="columns is-multiline la-carta-grid">
  
                {/* Carta Principal */}
                <div className="column is-full-tablet is-two-thirds-desktop">
                  <a href={this.props.apiHome.enlace_pdf_carta} title={this.props.apiHome.titulo_grid_carta}>
                    <div className="box-bg" style={this.bgCarta()}>
                      <div className="content-center">
                        <h3 className="icon-svg principal-svg">{this.props.apiHome.titulo_grid_carta}</h3>
                      </div>
                    </div>
                  </a>
                </div>
  
                {/* Desayunos */}
                <div className="column is-half-tablet is-one-third-desktop">
                  <a href={this.props.apiHome.enlace_pdf_coctel} title={this.props.apiHome.titulo_grid_coctel}>
                    <div className="box-bg" style={this.bgDesayunos()}>
                      <div className="content-center">
                        <h3 className="icon-svg desayunos-svg">{this.props.apiHome.titulo_grid_coctel}</h3>
                      </div>
                    </div>
                  </a>
                </div>
  
                {/* Bebidas */}
                <div className="column is-half-tablet is-one-third-desktop">
                  <a href={this.props.apiHome.enlace_pdf_vino} title={this.props.apiHome.titulo_grid_vino}>
                    <div className="box-bg" style={this.bgBebidas()}>
                      <div className="content-center">
                        <h3 className="icon-svg bebidas-svg">{this.props.apiHome.titulo_grid_vino}</h3>
                      </div>
                    </div>
                  </a>
                </div>
  
                {/* Postres */}
                <div className="column is-half-tablet is-one-third-desktop">
                  <div onClick={() => {this.startModal('modal1')}}>
                    <div className="box-bg" style={this.bgPostres()}>
                      <div className="content-center">
                        <h3 className="icon-svg postres-svg">{this.props.apiHome.titulo_grid_postres}</h3>
                      </div>
                    </div>
                  </div>
  
                  <div id="modal1" className="modal">
                    <div className="modal-background" onClick={() => {this.closeModal('modal1')}}></div>
                    <div className="modal-content">
  
                      <div className="popup">
                        <ul id="slides">
                          {this.sliderItems(this.props.apiHome.slider_postres)}
                        </ul>
  
                        <div className="buttons">
                          <button className="controls" id="previous">&lt;</button>
                          <button className="controls" id="next">&gt;</button>
                        </div>
  
                        <div className="columns popup-info">
                          <div className="column is-4">
                            <h3>{this.props.apiHome.titulo_grid_postres}</h3>
  
                          </div>
                          <div className="column is-8">
                            <p>{this.props.apiHome.texto_slider_postres}</p>
                          </div>
                        </div>
                      </div>
  
                    </div>
                    <button className="modal-close" click="closeModal('modal1')"></button>
                  </div>
  
                </div>
  
                {/* Para Llevar */}
                <div className="column is-half-tablet is-one-third-desktop">
                  <div onClick={() => { this.startModal('modal2') }}>
                    <div className="box-bg" style={this.bgLlevar()}>
                      <div className="content-center">
                        <h3 className="icon-svg llevar-svg">{this.props.apiHome.titulo_grid_llevar}</h3>
                      </div>
                    </div>
                  </div>
  
                  <div id="modal2" className="modal">
                    <div className="modal-background" onClick={() => { this.closeModal('modal2') }}></div>
                    <div className="modal-content">
  
                      <div className="popup">
                        <ul id="slides2">
                          {this.sliderItems(this.props.apiHome.slider_llevar)}
                        </ul>
  
                        <div className="buttons">
                          <button className="controls2" id="previous2">&lt;</button>
                          <button className="controls2" id="next2">&gt;</button>
                        </div>
                        <div className="columns popup-info">
                          <div className="column is-4">
                            <h3>{this.props.apiHome.titulo_grid_llevar}</h3>
  
                          </div>
                          <div className="column is-8">
                            <p>{this.props.apiHome.texto_slider_llevar}</p>
                          </div>
                        </div>
                      </div>
  
                    </div>
                    <button className="modal-close" click="closeModal('modal2')"></button>
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default LaCartaGrid;